import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ResponsivContent from "../../components/ResponsivContent";
import styles from "./styles.module.css";
import SendIcon from "@mui/icons-material/Send";
import MenuItem from "@mui/material/MenuItem";
import {
  alpha,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  styled,
  Switch,
  TextField,
} from "@mui/material";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import InputMask from "react-input-mask";
import { retornarDadosCnpj } from "../../services/api-cnpj.service";
import CloseIcon from "@mui/icons-material/Close";
import GenericDatePicker from "../../components/GenericDatePicker";
import { CadastroContext } from "../../config/Context/CadastroContext";
import { validarFormatacaoDocumento } from "../../services/validation.service";
import {
  consultaCnpjPorId,
  existeDuplicidade,
} from "../../services/auth.service";
import { LoginContext } from "../../config/Context/LoginContext";
import {
  buscarCheckpoint,
  obterPreCadastro,
} from "../../services/api-planejamento-tributario.service";

const initialForm = {
  cnpj: "",
  cpf: "",
  optante: "",
  todoPeriodo: "",
  periodo: "",
};

const BlueSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#18316e",
    "&:hover": {
      backgroundColor: alpha("#18316e", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#18316e",
  },
}));

const CadastrarCnpj = () => {
  const [dataForm, setDataForm] = useState(initialForm);
  const [dadosCnpj, setDadosCnpj] = useState(null);
  const [msg, setMsg] = useState("");
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [disableInputCnpj, setDisableInputCnpj] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const { dados, setDados } = useContext(CadastroContext);
  const { dadosLogin } = useContext(LoginContext);
  const navigate = useNavigate();

  const tipoDocumento = [
    // {
    //   value: "cpf",
    //   label: "CPF",
    // },
    {
      value: "cnpj",
      label: "CNPJ",
    },
  ];

  useEffect(() => {
    const handleCheckpoint = async () => {
      const initialData = await buscarCheckpoint();
      if (initialData?.checkpoint) {
        if (initialData.checkpoint.campos_preenchidos.dadosTitular.cnpj) {
          switch (dadosLogin.tipoCadastroPlanTribKey) {
            case "A":
              navigate("/cadastrar-associado-detalhado");
              break;
            case "P":
              navigate("/cadastrar-parceiro-detalhado");
              break;
            case "C":
              navigate("/cadastrar-cliente-detalhado");
              break;
            default:
              break;
          }
        }
      }
      setLoading(false);
      return;
    };

    handleCheckpoint();
  }, []);

  const pathCadastroDetalhado = () => {
    switch (dados.tipo) {
      case "A":
        return "/cadastrar-associado-detalhado";
      case "P":
        return "/cadastrar-parceiro-detalhado";
      case "C":
        return "/cadastrar-cliente-simples";
      default:
        return "";
    }
  };
  //verifica se o tipo do cadastro é Associado ou Parceiro - consulta se existe cnpj cadastro se for um dos dois
  useEffect(() => {
    if (dadosLogin.status !== "APROVADO") {
      const tipoDeUsuario = dadosLogin.tipoCadastroPlanTribKey;

      if (tipoDeUsuario === "P" || tipoDeUsuario === "A") {
        const cnpjCadastrado = async () => {
          try {
            const response = await consultaCnpjPorId(dadosLogin.idUsuario);

            if (response.cnpj) {
              setDisableInputCnpj(true);
              setDataForm((prevState) => ({
                ...prevState,
                cnpj: response.cnpj.replace(/\D/g, ""),
              }));
            }
            return;
          } catch (error) {
            console.log(error);
          }
        };

        cnpjCadastrado();
      }
    }
  }, []);

  const infoCnpj = async () => {
    const cnpjFormatado = dataForm.cnpj.replace(/\D/g, "");
    try {
      const response = await retornarDadosCnpj(cnpjFormatado);
      setDadosCnpj(response);
      setIsInvalid(false);
    } catch (error) {
      console.error(error);
      if (error.response) {
        if (error.response.status === 429) {
          setMsg(
            "Você fez muitas requisições. Por favor, aguarde 1 minuto para tentar novamente."
          );
        } else {
          setMsg(`Erro: ${error.response.data.message}`);
        }
      } else {
        setMsg("Erro ao buscar dados do CNPJ.");
      }
      handleOpenSnackbarErro();
    }
  };

  // const handleValidar = async () => {
  //   try {
  //     const existeDocumentoCadastrado = await existeDuplicidade(
  //       "cnpj",
  //       dataForm.cnpj.replace(/[.\-\/]/g, "")
  //     );
  //     return !existeDocumentoCadastrado.cadastrado;
  //   } catch (error) {
  //     return false;
  //   }
  // };

  useEffect(() => {
    const validar = async () => {
      const isCnpj = dados.tipoDocumento === "cnpj";

      if (isCnpj) {
        if (dataForm.cnpj.length === 18) {
          const isValid = await validarFormatacaoDocumento(
            dataForm.cnpj,
            "CNPJ"
          );
          setIsInvalid(!isValid);
          if (!isValid) {
            setMsg("CNPJ inválido!");
            handleOpenSnackbarErro();
            setDadosCnpj(null);
          } else {
            infoCnpj();
          }
        } else {
          setIsInvalid(true);
          setDadosCnpj(null);
        }
      } else {
        if (dataForm.cpf.length === 14) {
          const isValid = await validarFormatacaoDocumento(dataForm.cpf, "CPF");
          setIsInvalid(!isValid);
          if (!isValid) {
            setMsg("CPF inválido!");
            handleOpenSnackbarErro();
          } else {
            setMsg("CPF válido!");
            handleOpenSnackbarSucesso();
          }
        } else {
          setIsInvalid(true);
        }
      }
    };

    // validarECNPJ();
    validar();
  }, [dataForm.cnpj, dataForm.cpf]);

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarSucesso(false);
    setOpenSnackbarErro(true);
  };
  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };
  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarErro(false);
    setOpenSnackbarSucesso(true);
  };
  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setDataForm({ ...dataForm, ...initialForm });
    setOpenModal(false);
  };

  const handleSubmit = async () => {
    if (dados.tipoDocumento === "cnpj") {
      if (!isInvalid) {
        const isOptante = dadosCnpj?.simples?.optante;
        const isAtiva = dadosCnpj?.situacao === "ATIVA";
        if (!isAtiva || isOptante) {
          handleOpenModal();
          return;
        } else {
          setDados({
            ...dados,
            cnpj: dataForm.cnpj,
            cpf: "",
            cep: dadosCnpj.cep,
            logradouro: dadosCnpj.logradouro,
            complemento: dadosCnpj.complemento,
            numero: dadosCnpj.numero,
            cidade: dadosCnpj.municipio,
            estado: dadosCnpj.uf,
            bairro: dadosCnpj.bairro,
            nome: dadosCnpj.nome,
            email: dadosCnpj.email,
            telefone: dadosCnpj.telefone,
            dtAbertura: dadosCnpj.abertura
              ? dadosCnpj.abertura.split("/").reverse().join("-")
              : null,
            simplesDtOpcao: dadosCnpj.simples?.data_opcao
              ? dadosCnpj.simples.data_opcao.split("/").reverse().join("-")
              : null,
            simplesDtExclusao: dadosCnpj.simples?.data_exclusao
              ? dadosCnpj.simples.data_exclusao.split("/").reverse().join("-")
              : null,
          });
          navigate(pathCadastroDetalhado());
        }
      } else {
        setMsg("CNPJ inválido!");
        handleOpenSnackbarErro();
      }
    } else {
      if (!isInvalid) {
        setDados({
          ...dados,
          cpf: dataForm.cpf,
          cnpj: "",
          cep: "",
          logradouro: "",
          complemento: "",
          numero: "",
          cidade: "",
          estado: "",
          bairro: "",
          nome: "",
          email: "",
          telefone: "",
          dtAbertura: "",
          simplesDtOpcao: "",
          simplesDtExclusao: "",
        });
        navigate(pathCadastroDetalhado());
      } else {
        setMsg("CPF inválido!");
        handleOpenSnackbarErro();
      }
    }
  };

  const handleChangeDoc = (e) => {
    const value = e.target.value;
    if (dados.tipoDocumento === "cnpj") {
      setDataForm({ ...dataForm, cnpj: value, cpf: "" });
    } else {
      setDataForm({ ...dataForm, cnpj: "", cpf: value });
    }
  };

  const handleChangeSelect = (e) => {
    setDados({ ...dados, tipoDocumento: e.target.value });
  };

  return (
    <>
      {!loading ? (
        <div className={styles.main}>
          <ResponsivContent>
            <h2 className={styles.title}>Digite um CNPJ/CPF válido:</h2>
            <div className={styles.separador}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <TextField
                    id="outlined-select-currency"
                    select
                    size="small"
                    fullWidth
                    onChange={handleChangeSelect}
                    value={dados.tipoDocumento}
                    label="Documento"
                    defaultValue="CNPJ"
                  >
                    {tipoDocumento.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={8}
                  // sm={dadosCnpj ? 6 : 12}
                  // sx={{ marginBottom: "2rem" }}
                >
                  <InputMask
                    disabled={disableInputCnpj}
                    mask={
                      dados.tipoDocumento === "cnpj"
                        ? "99.999.999/9999-99"
                        : "999.999.999-99"
                    }
                    maskChar={null}
                    name="cnpj"
                    onChange={handleChangeDoc}
                    value={
                      dados.tipoDocumento === "cnpj"
                        ? dataForm.cnpj
                        : dataForm.cpf
                    }
                  >
                    {() => (
                      <TextField
                        disabled={disableInputCnpj}
                        size="small"
                        label={dados.tipoDocumento.toUpperCase()}
                        name="cnpj"
                        fullWidth
                        required
                        inputProps={{ 'data-only': 'numeric' }}
                      />
                    )}
                  </InputMask>
                </Grid>
                {dadosCnpj && dados.tipoDocumento === "cnpj" ? (
                  <>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        size="small"
                        label="Razão Social"
                        fullWidth
                        value={dadosCnpj?.nome}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        size="small"
                        label="Nome Fantasia"
                        fullWidth
                        value={
                          dadosCnpj?.fantasia !== "" ? dadosCnpj?.fantasia : "-"
                        }
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <TextField
                        size="small"
                        label="Data Inicio da Atividade"
                        fullWidth
                        value={dadosCnpj?.abertura}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        size="small"
                        label="E-mail"
                        fullWidth
                        value={dadosCnpj?.email}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControl>
                        <FormLabel sx={{ fontSize: "0.8rem" }}>
                          Optante pelo Simples Nacional
                        </FormLabel>
                        <h5
                          style={{
                            margin: 0,
                            color: dadosCnpj?.simples?.optante
                              ? "red"
                              : "green",
                          }}
                        >
                          {dadosCnpj?.simples?.optante ? "Sim" : "Não"}
                        </h5>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <FormControl>
                        <FormLabel sx={{ fontSize: "0.8rem" }}>
                          Situação Cadastral
                        </FormLabel>
                        <h5
                          style={{
                            margin: 0,
                            color:
                              dadosCnpj?.situacao === "ATIVA" ? "green" : "red",
                          }}
                        >
                          {dadosCnpj?.situacao === "ATIVA"
                            ? "Ativo"
                            : "Inativo"}
                        </h5>
                      </FormControl>
                    </Grid>
                  </>
                ) : (
                  ""
                )}
              </Grid>
            </div>
            <div className={styles.botoes}>
              {dadosCnpj &&
              dados.tipoDocumento === "cnpj" &&
              dados.tipo === "C" ? (
                <div className={styles.switch}>
                  <p style={{ textAlign: "center" }}>É Matriz?</p>
                  <BlueSwitch
                    checked={dados.is_matriz}
                    onChange={() =>
                      setDados({ ...dados, is_matriz: !dados.is_matriz })
                    }
                  />
                </div>
              ) : (
                <div></div>
              )}
              <Button
                className={styles.botaoProsseguir}
                variant="contained"
                onClick={handleSubmit}
                startIcon={
                  <SendIcon sx={{ marginRight: "0.2rem", color: "white" }} />
                }
              >
                Prosseguir
              </Button>
            </div>
          </ResponsivContent>

          <Dialog open={openModal} onClose={handleCloseModal}>
            <DialogTitle>CNPJ Inválido</DialogTitle>
            <DialogContent>
              <p className={styles.paragrafo}>
                Infelizmente não poderemos seguir o cadastro com o CNPJ
                informado.
              </p>
              {dadosCnpj?.situacao !== "ATIVA" && (
                <p className={styles.paragrafo}>
                  O CNPJ não está com a Situação Cadastral{" "}
                  <strong>Ativa</strong>.
                </p>
              )}
              {dadosCnpj?.simples?.optante && (
                <p className={styles.paragrafo}>
                  A empresa informada é optante pelo{" "}
                  <strong>Simples Nacional</strong>.
                </p>
              )}
              <p className={styles.paragrafo}>
                Informe um novo CNPJ para prosseguir ou conheça outros serviços
                que podemos oferecer.
              </p>
              <div className={styles.botoes}>
                <Button
                  variant="contained"
                  onClick={handleCloseModal}
                  className={styles.btnModal}
                >
                  Tentar outro CNPJ
                </Button>
                <Button
                  variant="contained"
                  onClick={() => navigate("/sugestao-de-servicos")}
                  className={styles.btnModal}
                >
                  Conhecer serviços
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          <MensagemSucesso
            open={openSnackbarSucesso}
            handleClose={handleCloseSnackbarSucesso}
            msg={msg}
          />

          <MensagemErro
            open={openSnackbarErro}
            handleClose={handleCloseSnackbarErro}
            msg={msg}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default CadastrarCnpj;
